import http from "../../utils/http";

// 원격 요청 리스트
export const getRemoteList = (params = {}) =>
  new Promise((resolve, reject) => {
    http
      .post(`/remote/master/list`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });

// 원격 요청 생성
export const addRemote = (params) =>
  new Promise((resolve, reject) => {
    http
      .post(`/remote`, {
        ...params,
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });

// 원격 요청 삭제
export const deleteRemote = (remoteType, idx) =>
  new Promise((resolve, reject) => {
    http
      .delete(`/remote/${remoteType}/${idx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });

// 원격 요청 수정
export const modifyRemote = (idx, params) =>
  new Promise((resolve, reject) => {
    http
      .put(`/remote/${idx}`, {
        ...params,
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const getRemote = (idx) =>
  new Promise((resolve, reject) => {
    http
      .get(`/remote/${idx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
